import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SKIP = ["localhost", "127.0.0.1", "preview.emergentagent.com", "emergentcf.cloud"];
let _site;

export const getSite = () => {
  if (!_site) _site = axios.get(`${API}/public/site`).then((r) => r.data).catch(() => { _site = null; return {}; });
  return _site;
};

// Follow a stored 301 for this path (client-side until the host routes these paths to the server).
export async function followRedirect(path, navigate, redirect) {
  let to = redirect;
  if (to === undefined) {
    try { to = (await axios.get(`${API}/public/resolve`, { params: { path } })).data.redirect; } catch { to = null; }
  }
  if (!to) return false;
  if (/^https?:\/\//.test(to)) window.location.replace(to);
  else navigate(to, { replace: true });
  return true;
}

export function HostRedirect() {
  useEffect(() => {
    const h = window.location.hostname;
    if (SKIP.some((s) => h.includes(s))) return;
    getSite().then(({ canonical_host }) => {
      if (canonical_host && h !== canonical_host) {
        const { pathname, search, hash } = window.location;
        window.location.replace(`https://${canonical_host}${pathname}${search}${hash}`);
      }
    });
  }, []);
  return null;
}
